import {hexToRGBString} from '@daedalus/core/src/utils/string'

import {colors} from './colors'

const shadowRgb = hexToRGBString(colors.shadow)
const anchorRgb = hexToRGBString(colors.background.brand.c900)
const inputInnerRgb = hexToRGBString(colors.border.inverse.c950)

export const shadows = {
  flat: 'none',
  action: `0px 1px 4px rgba(${shadowRgb}, 0.12), 0px 0px 1px rgba(${shadowRgb}, 0.08)`,
  fixed: `0px 2px 8px rgba(${shadowRgb}, 0.1), 0px 0px 2px rgba(${shadowRgb}, 0.1)`,
  raised: `0px 3px 12px rgba(${shadowRgb}, 0.12), 0px 0px 3px rgba(${shadowRgb}, 0.1)`,
  hover: `0px 4px 16px rgba(${shadowRgb}, 0.12), 0px 3px 4px rgba(${shadowRgb}, 0.12)`,
  floating: `0px 6px 24px rgba(${shadowRgb}, 0.12), 0px 4px 8px rgba(${shadowRgb}, 0.14)`,
  modal: `0px 8px 32px rgba(${shadowRgb}, 0.16), 0px 6px 8px rgba(${shadowRgb}, 0.16)`,
  fixedReverse: `0px -2px 8px rgba(${shadowRgb}, 0.1), 0px 0px 2px rgba(${shadowRgb}, 0.1)`,
  bottomSheets: `0px -6px 24px rgba(${shadowRgb}, 0.12), 0px -4px 8px rgba(${shadowRgb}, 0.12)`,
  // Anchor shadows
  anchor: `0px 3px 12px rgba(${anchorRgb}, 0.16), 0px 0px 3px rgba(${anchorRgb}, 0.12)`,
  anchorHover: `0px 4px 16px rgba(${anchorRgb}, 0.2), 0px 3px 4px rgba(${anchorRgb}, 0.16)`,
  // Input shadows
  inputInner: `inset 0px 2px 4px rgba(${inputInnerRgb}, 0.05)`
}
